import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Branch = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5C11 6.30622 10.1652 7.41746 9 7.82929V12.0351C9.58835 11.6948 10.2714 11.5 11 11.5H14C15.1046 11.5 16 10.6046 16 9.5V7.82929C14.8348 7.41746 14 6.30622 14 5C14 3.34315 15.3431 2 17 2C18.6569 2 20 3.34315 20 5C20 6.30622 19.1652 7.41746 18 7.82929V9.5C18 11.7091 16.2091 13.5 14 13.5H11C9.89543 13.5 9 14.3954 9 15.5V16.1707C10.1652 16.5825 11 17.6938 11 19C11 20.6569 9.65685 22 8 22C6.34315 22 5 20.6569 5 19C5 17.6938 5.83481 16.5825 7 16.1707V7.82929C5.83481 7.41746 5 6.30622 5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5ZM8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6ZM9 19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19C7 18.4477 7.44772 18 8 18C8.55228 18 9 18.4477 9 19ZM18 5C18 5.55228 17.5523 6 17 6C16.4477 6 16 5.55228 16 5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5Z"
      fill="currentColor"
    />
  </Icon>
));

export default Branch;
